import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-page-contentboxes',
  templateUrl: './page-contentboxes.component.html'
})
export class PageContentboxesComponent implements OnInit {
  public query: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }

}
